module.exports = __webpack_public_path__ + "img/img-event-m-tab-05.61a9d0f1.png";